import { render } from "./address-edit.vue?vue&type=template&id=6c0dfde9&scoped=true"
import script from "./address-edit.vue?vue&type=script&lang=js"
export * from "./address-edit.vue?vue&type=script&lang=js"

import "./address-edit.vue?vue&type=style&index=0&id=6c0dfde9&scoped=true&lang=css"

import exportComponent from "/studio/gordon/Studio/mylink-intgr/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c0dfde9"]])

export default __exports__